import React from 'react';
import { Paper, Typography } from '@mui/material';
import { generateDailyCode } from '../../utils';

const DailyCode = () => {
    return (
        <Paper
            sx={{
                p: 2,
                mb: 2,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography variant="h5" component="div">
                Codigo: {generateDailyCode()}
            </Typography>
        </Paper>
    );
};

export default DailyCode;
